import { 
  apiService, 
  AuthLoginResponseDto, 
  AuthVerifyResponseDto, 
  RegisterAccountDto, 
  EmailConfirmationResponseDto,
  LoginResponseDto 
} from './api';

export class AuthService {
  /**
   * Send magic link login email
   */
  async login(email: string, recaptchaToken?: string): Promise<AuthLoginResponseDto> {
    return apiService.login(email, recaptchaToken);
  }

  /**
   * Verify authentication token from magic link
   */
  async verifyToken(token: string, landingUrl?: string, additionalParams?: Record<string, string>): Promise<AuthVerifyResponseDto> {
    return apiService.verifyToken(token, landingUrl, additionalParams);
  }

  /**
   * Register a new account with first monitored identity
   */
  async register(userData: RegisterAccountDto): Promise<LoginResponseDto> {
    return apiService.registerAccount(userData);
  }

  /**
   * Confirm email address
   */
  async confirmEmail(token: string): Promise<EmailConfirmationResponseDto> {
    return apiService.confirmEmail(token);
  }
}

export const authService = new AuthService();